import { render, staticRenderFns } from "./IssuesBarChart.vue?vue&type=template&id=12ed8b4a&scoped=true&"
import script from "./IssuesBarChart.vue?vue&type=script&lang=js&"
export * from "./IssuesBarChart.vue?vue&type=script&lang=js&"
import style0 from "./IssuesBarChart.vue?vue&type=style&index=0&id=12ed8b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed8b4a",
  null
  
)

export default component.exports